import { helper as buildHelper } from '@ember/component/helper';
import { ACTIVITY_FEED_ITEM } from '../../models/activity-feed-item';

/**
 * Given the feedable_type and feedable_id, build the correct URI to legacy lar4 resources.
 *
 * @param params
 * @returns {string}
 */
export function lar4UrlBuildersFeedable(params/*, hash*/) {
  let feedableType = params[0],
    feedableId = params[1],
    uri = '';

  switch (feedableType) {
    case ACTIVITY_FEED_ITEM.TYPES.APPLICATION:
      uri = `/project/${feedableId}`;
      break;
    case ACTIVITY_FEED_ITEM.TYPES.ASSIGNMENT:
      uri = `/posting/${feedableId}`;
      break;
    case ACTIVITY_FEED_ITEM.TYPES.PAYOUT_ACCOUNT:
      uri = `/settings/payout`;
      break;
  }

  if (!uri) {
    throw new Error('No feedable type for id ' + feedableId);
  }

  return uri;
}

export default buildHelper(lar4UrlBuildersFeedable);
